export type FootnoteFieldInfo = {
  fieldId: string;
  fieldLabel: string;
  fieldName: string;
  contextRef: string;
  qname: string;
  currentYearContext: string;
  comparativeYearContext: string;
  currentYear: string;
  comparativeYear: string;
  memberType: string;
  isReadonly: boolean;
};

export type FootnoteCompanyInfo = {
  consolidated: string;
  first_year: string;
};

export type FootnoteOnUpdateField = (
  fieldName: string,
  contextRef: string,
  value: string,
  qname: string
) => void;

type FootnoteModalContext = {
  fieldInfo: FootnoteFieldInfo;
  companyInfo: FootnoteCompanyInfo;
  onUpdateField?: FootnoteOnUpdateField;
  onMarkDirty?: () => void;
};

let currentContext: FootnoteModalContext | null = null;

export const FOOTNOTE_MODAL_OPEN_EVENT = 'footnoteModal:open';
export const FOOTNOTE_MODAL_CLOSE_EVENT = 'footnoteModal:close';

export function setFootnoteModalContext(ctx: FootnoteModalContext) {
  currentContext = ctx;
}

export function getFootnoteModalContext() {
  return currentContext;
}

export function openFootnoteModal() {
  document.dispatchEvent(new CustomEvent(FOOTNOTE_MODAL_OPEN_EVENT));
}

export function closeFootnoteModal() {
  document.dispatchEvent(new CustomEvent(FOOTNOTE_MODAL_CLOSE_EVENT));
}


